import { atom } from "jotai";

export const imageUrlToDisplayState = atom(null);